import { GpsDataStatus } from 'app/constants/gpsDataStatus'

export const getGpsStatus = (type: number) => {
  let gpsDataStatus = GpsDataStatus.Verified

  switch (type) {
    case 1:
      gpsDataStatus = GpsDataStatus.InvalidCountry
      break
    case 2:
      gpsDataStatus = GpsDataStatus.InProgress
      break
    case 3:
      gpsDataStatus = GpsDataStatus.SetByUser
      break
  }

  return gpsDataStatus
}
